export default __webpack_public_path__ + "static/media/spin-bg-16.c6bb5a0b.png";